'use client'

import { useEffect, useState } from 'react'

// One line every page shows while part of the site is paused for a database upgrade: the backend's /api/site_notice
// answers it only while its store is paused (promptchan-backend blueprints/site_notice_bp.py), so it appears and goes
// away by itself. Asked once a minute while the tab is visible; a failed ask shows nothing (it is a courtesy, never an
// error of its own).
const EVERY_MS = 60000

export default function SiteNotice() {
  const [notice, setNotice] = useState(null)

  useEffect(() => {
    let stopped = false
    const ask = async () => {
      if (document.visibilityState !== 'visible') return
      try {
        const response = await fetch(
          `${process.env.NEXT_PUBLIC_PROMPTCHAN_CLOUD}/api/site_notice`,
        )
        if (!response.ok) return
        const body = await response.json()
        if (!stopped) setNotice(body?.notice || null)
      } catch {
        // nothing to show
      }
    }
    ask()
    const timer = setInterval(ask, EVERY_MS)
    document.addEventListener('visibilitychange', ask)
    return () => {
      stopped = true
      clearInterval(timer)
      document.removeEventListener('visibilitychange', ask)
    }
  }, [])

  if (!notice) return null
  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-x-0 top-0 z-[120] bg-amber-400 px-4 py-2 text-center text-sm font-medium text-black shadow-md"
    >
      {notice}
    </div>
  )
}
